import * as signalR from "@aspnet/signalr";

const configuration = {} as any;
//
try {
    configuration.APP_NAME = process.env.REACT_APP_NAME;
    configuration.API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    configuration.dev =
    {
        enableReduxDevToolsExtension: process.env.REACT_APP_DEV_ENABLE_REDUX_DEV_TOOLS_EXTENSION === "true"
    };
    configuration.API_HUBS =
    {
        WARP_HUB: process.env.REACT_APP_API_HUBS_WARP_HUB
    }
    configuration.SIGNALR =
    {
        logLevel :  signalR.LogLevel[process.env.REACT_APP_SIGNALR_LOG_LEVEL as keyof typeof signalR.LogLevel]//process.env.REACT_APP_SIGNALR_LOG_LEVEL as keyof typeof signalR.LogLevel]
    }
    //
    configuration.DASHBOARD =
    {
        ApiUrl: process.env.REACT_APP_DASHBOARD_API_URL,
        AllowEdit : process.env.REACT_APP_DASHBOARD_ALLOW_EDIT === "true",
    }
    //
    //console.log(configuration);
    //console.log(process.env);
} catch (e) {
}
export default configuration;
